export default {
  blockrule: null,
  blockrules: null,
  totalBlockrules: null,
  customersBlocked: null,
  totalCustomersBlocked: null
};
